import React from 'react'
import styled from 'styled-components'

export const StyledPane = styled(
  ({
    children,
    direction,
    grow,
    justifyContent,
    alignItems,
    width,
    height,
    padding,
    margin,
    wrap,
    backgroundColor,
    borderRadius,
    z_index,
    boxShadow,
    cursor,
    position,
    ...rest
  }) => <div {...rest}>{children}</div>
)`
  display: flex;
  box-sizing: border-box;
  flex-direction: ${({ direction }) => direction};
  flex-grow: ${({ grow }) => grow};
  justify-content: ${({ justifyContent }) => justifyContent};
  align-items: ${({ alignItems }) => alignItems};
  width: ${({ width }) => width};
  height: ${({ height }) => height};
  padding: ${({ padding }) => padding};
  margin: ${({ margin }) => margin};
  flex-wrap: ${({ wrap }) => (wrap ? 'flex-wrap' : 'no-wrap')};
  background-color: ${({ backgroundColor }) => backgroundColor};
  border-radius: ${({ borderRadius }) => borderRadius};
  z-index: ${({ z_index }) => z_index};
  box-shadow: ${({ boxShadow }) => boxShadow};
  cursor: ${({ cursor }) => cursor};
  position: ${({ position }) => position};
`

StyledPane.defaultProps = {
  grow: 0,
  width: 'auto',
  height: 'auto',
  padding: '0',
  margin: '0',
  direction: 'row',
  justifyContent: 'flex-start',
  alignItems: 'stretch',
  wrap: false,
  backgroundColor: 'none',
  borderRadius: 'none',
  z_index: 'none',
  boxShadow: 'none',
}
